webpackJsonp([11],{

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(356),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTcuNDEgOC41OUwxMiAxMy4xN2w0LjU5LTQuNThMMTggMTBsLTYgNi02LTYgMS40MS0xLjQxeiIvPjwvc3ZnPg==");

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAyMiI+PGRlZnM+PHN0eWxlPi5sZXNzb24tY2xzLTF7ZmlsbDojZmY1NTgzO30ubGVzc29uLWNscy0ye2ZpbGw6bm9uZTtzdHJva2U6IzZhMDkyMztzdHJva2Utd2lkdGg6MnB4O30ubGVzc29uLWNscy0ze2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfMjQxIiBkYXRhLW5hbWU9Ikdyb3VwIDI0MSI+PGcgaWQ9IlJlY3RhbmdsZV82NzYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDY3NiI+PHJlY3QgY2xhc3M9Imxlc3Nvbi1jbHMtMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjIyIiByeD0iNCIvPjxyZWN0IGNsYXNzPSJsZXNzb24tY2xzLTIiIHg9IjEiIHk9IjEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyMCIgcng9IjMiLz48L2c+PHBhdGggaWQ9IlBvbHlnb25fNTciIGRhdGEtbmFtZT0iUG9seWdvbiA1NyIgY2xhc3M9Imxlc3Nvbi1jbHMtMyIgZD0iTTE2LjE0LDcuMTJhMSwxLDAsMCwxLDEuMzcuMzYsMSwxLDAsMCwxLC4xNC41MWwwLDYuNmExLDEsMCwwLDEtMS41Ljg2bC01LjY3LTMuMjdhMSwxLDAsMCwxLS4zNy0xLjM3LDEsMSwwLDAsMSwuMzYtLjM3WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==");

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDMuNUwyIDVMNiAxIiBzdHJva2U9IiMzZjcyMzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIycHgiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4yOCAyMi43NSI+PGRlZnM+PHN0eWxlPi53b3Jkcy1jbHMtMXtmaWxsOiM1NTVmZmY7fS53b3Jkcy1jbHMtMiwud29yZHMtY2xzLTN7ZmlsbDpub25lO30ud29yZHMtY2xzLTN7c3Ryb2tlOiMxMTk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfODQiIGRhdGEtbmFtZT0iR3JvdXAgODQiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJ3b3Jkcy1jbHMtMSIgZD0iTTQsMTUuMTJjMS43Ny4wNywxNC4zNCwwLDE0LjM0LDBsLTEuNTcsNi42M0g1LjVaIi8+PHBhdGggaWQ9IlBhdGhfMjYiIGRhdGEtbmFtZT0iUGF0aCAyNiIgY2xhc3M9IndvcmRzLWNscy0xIiBkPSJNMi44MywxMS4yYzIsLjA2LDE2LjQ2LDAsMTYuNDYsMEwxNy40OSwxN0g0LjU4WiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJ3b3Jkcy1jbHMtMiIgeDE9IjMuNTQiIHkxPSIxMS4yIiB4Mj0iMTguNzkiIHkyPSIxMS4yIi8+PGxpbmUgaWQ9IkxpbmVfMTMiIGRhdGEtbmFtZT0iTGluZSAxMyIgY2xhc3M9IndvcmRzLWNscy0yIiB4MT0iMi41MiIgeTE9IjUuODEiIHgyPSIxOS43NCIgeTI9IjUuOCIvPjxwYXRoIGlkPSJQYXRoXzI0IiBkYXRhLW5hbWU9IlBhdGggMjQiIGNsYXNzPSJ3b3Jkcy1jbHMtMyIgZD0iTTEuMTYsMWMxLjM2LjA1LDE0LjEzLDAsMTguODIsMGgxLjE1cy0zLDIwLjcxLTUsMjAuNzFINkM0LjEzLDIxLjc1LDEuMTYsMSwxLjE2LDFaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4yOCAyMi43NSI+PGRlZnM+PHN0eWxlPi53b3Jkc2Z1bGwtY2xzLTF7ZmlsbDojN2NlYTM3O30ud29yZHNmdWxsLWNscy0yLC53b3Jkc2Z1bGwtY2xzLTN7ZmlsbDpub25lO30ud29yZHNmdWxsLWNscy0ze3N0cm9rZTojMTQ2MDBlO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PGcgaWQ9Ikdyb3VwXzIzNiIgZGF0YS1uYW1lPSJHcm91cCAyMzYiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTEiIGQ9Ik00LDE1LjEyYzEuNzcuMDcsMTQuMzQsMCwxNC4zNCwwbC0xLjU3LDYuNjNINS41WiIvPjxwYXRoIGlkPSJQYXRoXzI2IiBkYXRhLW5hbWU9IlBhdGggMjYiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTEiIGQ9Ik0xLjY2LDEuN2MyLjI5LjE3LDE4LjU1LDAsMTguNTUsMEwxOC4xOCwxN0gzLjYzWiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTIiIHgxPSIzLjU0IiB5MT0iMTEuMiIgeDI9IjE4Ljc5IiB5Mj0iMTEuMiIvPjxsaW5lIGlkPSJMaW5lXzEzIiBkYXRhLW5hbWU9IkxpbmUgMTMiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTIiIHgxPSIyLjUyIiB5MT0iNS44MSIgeDI9IjE5Ljc0IiB5Mj0iNS44Ii8+PHBhdGggaWQ9IlBhdGhfMjQiIGRhdGEtbmFtZT0iUGF0aCAyNCIgY2xhc3M9IndvcmRzZnVsbC1jbHMtMyIgZD0iTTEuMTYsMWMxLjM2LjA1LDE0LjEzLDAsMTguODIsMGgxLjE1cy0zLDIwLjcxLTUsMjAuNzFINkM0LjEzLDIxLjc1LDEuMTYsMSwxLjE2LDFaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMy4wNCAyMy43NSI+PGRlZnM+PHN0eWxlPi5ncmFtbWFyLWNscy0xe2ZpbGw6IzU1NWZmZjtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBpZD0iUGF0aF8xMTMiIGRhdGEtbmFtZT0iUGF0aCAxMTMiIGNsYXNzPSJncmFtbWFyLWNscy0xIiBkPSJNMzIsMSwxNi40MSw2LjYzSDIuNzFMMSwyMi43NUgxOC4xTDE2LjQxLDYuODkiLz48L2c+PC9nPjwvc3ZnPg==");

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC4yMyAzNS44NSI+PGRlZnM+PHN0eWxlPi5zZW4tY2xzLTF7ZmlsbDojNTU1ZmZmO30uc2VuLWNscy0yLC5zZW4tY2xzLTMsLnNlbi1jbHMtNCwuc2VuLWNscy01e2ZpbGw6bm9uZTt9LnNlbi1jbHMtM3tzdHJva2U6IzU1NWZmZjt9LnNlbi1jbHMtMywuc2VuLWNscy01e3N0cm9rZS13aWR0aDoycHg7fS5zZW4tY2xzLTQsLnNlbi1jbHMtNXtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpyb3VuZDt9LnNlbi1jbHMtNHtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxnIGlkPSJHcm91cF8yMzkiIGRhdGEtbmFtZT0iR3JvdXAgMjM5Ij48cGF0aCBpZD0iUGF0aF84NiIgZGF0YS1uYW1lPSJQYXRoIDg2IiBjbGFzcz0ic2VuLWNscy0xIiBkPSJNMTMsMTYuNDhsMTMuNjUtLjYxTDIwLjMsMjMuNzJaIi8+PGcgaWQ9Ikdyb3VwXzE3MyIgZGF0YS1uYW1lPSJHcm91cCAxNzMiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJzZW4tY2xzLTEiIGQ9Ik0yLjg3LDMwLjgyYzEuMDgsMCw4LjcxLDAsOC43MSwwbC0uOTUsNEgzLjhaIi8+PHBhdGggaWQ9IlBhdGhfMjYiIGRhdGEtbmFtZT0iUGF0aCAyNiIgY2xhc3M9InNlbi1jbHMtMSIgZD0iTTIuMTgsMjguNDRjMS4yMywwLDEwLDAsMTAsMEwxMS4wOCwzMkgzLjI0WiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJzZW4tY2xzLTIiIHgxPSIyLjYxIiB5MT0iMjguNDQiIHgyPSIxMS44NyIgeTI9IjI4LjQ0Ii8+PGxpbmUgaWQ9IkxpbmVfMTMiIGRhdGEtbmFtZT0iTGluZSAxMyIgY2xhc3M9InNlbi1jbHMtMiIgeDE9IjEuOTkiIHkxPSIyNS4xNiIgeDI9IjEyLjQ1IiB5Mj0iMjUuMTYiLz48L2c+PHBhdGggaWQ9IlBhdGhfODUiIGRhdGEtbmFtZT0iUGF0aCA4NSIgY2xhc3M9InNlbi1jbHMtMyIgZD0iTTI1LjY2LDE2LjE3bC0xNC44NC4zOS0xLjA4LjY4VjI5LjlMOC4zOCwzMS4zMyIvPjxwYXRoIGlkPSJQYXRoXzg0IiBkYXRhLW5hbWU9IlBhdGggODQiIGNsYXNzPSJzZW4tY2xzLTQiIGQ9Ik0yMi4wNiwxbC0zLjQ4LDkuNDctNS42Niw2LjM3aC4zMmw2LjgzLDcuMDksNi42Ny04TDE5LDEwLjgyIi8+PHBhdGggaWQ9IlBhdGhfODgiIGRhdGEtbmFtZT0iUGF0aCA4OCIgY2xhc3M9InNlbi1jbHMtNSIgZD0iTTEuMTYsMjIuMjdjLjgzLDAsOC41OCwwLDExLjQzLDBoLjdzLTEuODEsMTIuNTgtMywxMi41OEg0LjFDMywzNC44NSwxLjE2LDIyLjI3LDEuMTYsMjIuMjdaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    lessonMaterials: null
  },
  mutations: {
    setLessonMaterials: function setLessonMaterials(state, payload) {
      state.lessonMaterials = payload;
    }
  },
  actions: {
    getLessonMaterials: function getLessonMaterials(_ref) {
      var commit = _ref.commit;
      var _getters$user$courseV = this.getters.user.courseViewLocation,
          chapter = _getters$user$courseV.chapter,
          lesson = _getters$user$courseV.lesson;

      commit("setLoading", true);

      if (this.getters.lessonMaterialsData && this.getters.lessonMaterialsData.length > 0) {
        commit("setLessonMaterials", this.getters.lessonMaterialsData);
        return commit("setLoading", false);
      }
      var URL = "https://us-central1-meduberet-project.cloudfunctions.net/fetchLessonMaterials?chapter=" + chapter + "&lesson=" + lesson;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: URL,
        headers: {
          "Content-Type": "text/plain"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        commit("setLessonMaterials", data.materials);
        commit("setLoading", false);
      }).catch(function (err) {
        console.error(err);
        return null;
      });
    }
  },
  getters: {
    lessonMaterials: function lessonMaterials(state) {
      return state.lessonMaterials;
    }
  }
});

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video_scss__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Video_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Video_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_left_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_lesson_svg__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_wordshalf_svg__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_wordsfull_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_grammar_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_sentences_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_course__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_courseService__ = __webpack_require__(77);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Video",
  props: ["permission"],
  data: function data() {
    return {
      playUrl: null,
      // videos: null,
      chapter: null,
      pickedQa: null,
      sounds: false,
      speachSet: true,
      pickedType: "",
      Arrow: __WEBPACK_IMPORTED_MODULE_3__assets_svg_arrow_left_svg__["default"],
      imgTypes: {
        lesson: __WEBPACK_IMPORTED_MODULE_4__assets_svg_lesson_svg__["default"],
        wordshalf: __WEBPACK_IMPORTED_MODULE_5__assets_svg_wordshalf_svg__["a" /* default */],
        wordsfull: __WEBPACK_IMPORTED_MODULE_6__assets_svg_wordsfull_svg__["a" /* default */],
        grammar: __WEBPACK_IMPORTED_MODULE_7__assets_svg_grammar_svg__["a" /* default */],
        sentences: __WEBPACK_IMPORTED_MODULE_8__assets_svg_sentences_svg__["a" /* default */]
      },
      types: {
        lesson: "\u05E9\u05D9\u05E2\u05D5\u05E8",
        wordshalf: "\u05D7\u05E6\u05D0\u05D9 \u05DE\u05D9\u05DC\u05D9\u05DD",
        wordsfull: "\u05DE\u05D9\u05DC\u05D9\u05DD",
        sentences: "\u05D4\u05E8\u05DB\u05D1\u05EA \u05DE\u05E9\u05E4\u05D8\u05D9\u05DD",
        grammar: "\u05D3\u05E7\u05D3\u05D5\u05E7"
      }
    };
  },
  created: function created() {
    // this.videos = await courseService.getVideos();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    videos: function videos() {
      return this.$store.getters.videos;
    },
    numberOfQ: function numberOfQ() {
      var numberOfQ = 6;
      return numberOfQ;
    },
    user: function user() {
      return this.$store.getters.user;
    },
    getRank: function getRank() {
      if (this.user) {
        return this.user.user_rank;
      } else {
        return 0;
      }
    },
    countSentences: function countSentences() {
      if (this.user) {
        return this.user.sentences_score / 10;
      } else {
        return 0;
      }
    },
    countWords: function countWords() {
      if (this.user) {
        return this.user.words_score;
      } else {
        return 0;
      }
    },
    countLaws: function countLaws() {
      if (this.user) {
        return this.user.rules_score / 5;
      } else {
        return 0;
      }
    },
    userProgress: function userProgress() {
      if (this.user && this.user.lessons) {
        return this.user.lessons.filter(function (lesson) {
          return lesson.is_done === true;
        }).map(function (les) {
          return les.lesson.id;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    openPlayer: function openPlayer(url) {
      this.playUrl = url;
    },
    openLesson: function openLesson(id, permission) {
      if (permission === "paying" && this.permission !== "paying") {
        // this.text = "רק למשתמשים משלמים";
        // this.snacktype = "paid";
        // this.snackbar = true;
        // console.log("reg only");
        this.goPay();
        return;
      }
      if (permission !== "unknown" && permission !== this.permission && this.permission !== "paying") {
        this.goPay();
        return;
      }
      this.$router.push("/lesson/" + id);
    },
    goPay: function goPay() {
      this.$router.push({
        path: "/registration"
      });
    },

    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=1&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
    },
    calculateHeight: function calculateHeight(type) {
      console.log(type);
      return this.pickedType === type ? type.lessons.length * 60 + 70 + "px" : "54px";
    },
    pickType: function pickType(type) {
      if (this.pickedType === type) {
        this.pickedType = "";
        return;
      }
      this.pickedType = type;
    },
    goBack: function goBack() {
      this.playUrl = null;
    },

    goTo: function goTo(lesson) {
      // this.$store.commit({
      //   type: "setCurrentGame",
      //   lesson,
      //   courseId: course.order,
      //   courseName: course.name
      // });
      // this.$router.push({
      //   path: `../play/${lesson.type}/${lesson.game_id}`
      // });
      console.log("OK");
    }
  },
  watch: {},
  components: { VideoPlayer: __WEBPACK_IMPORTED_MODULE_10__Shared_VideoPlayer_vue___default.a }
});

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("803aca42", content, true, {});

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".lessons-wrapper{display:flex;flex-direction:column;padding:16px 16px 0 16px}.gameText{margin-inline-start:8px}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Videos/src/components/Videos/Video.scss"],"names":[],"mappings":"AAAA,iBACE,aACA,sBACA,wBAAA,CAGF,UACE,uBAAA,CAAA","file":"Video.scss","sourcesContent":[".lessons-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px 0 16px;\n}\n\n.gameText {\n  margin-inline-start: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-chapter"
  }, [(!_vm.videos) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t("video.video.loading")) + "\n      "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.playUrl) ? _c('div', {
    staticClass: "player"
  }, [_c('h3', [_vm._v(_vm._s(_vm.playUrl.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.playUrl.description))]), _vm._v(" "), _c('VideoPlayer', {
    staticClass: "videoPlayer",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.playUrl.url)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "done",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("video.video.finish")) + "\n      ")])], 1) : (_vm.videos) ? _c('div', {
    staticClass: "chapter-course"
  }, _vm._l((_vm.videos), function(section) {
    return _c('div', {
      staticClass: "collapsed",
      style: ({
        height: _vm.calculateHeight(section)
      })
    }, [_c('div', {
      staticClass: "lesson-type",
      on: {
        "click": function($event) {
          return _vm.pickType(section)
        }
      }
    }, [_c('div', [_c('div', [_c('h5', [_vm._v(_vm._s(section["title"]))])])]), _vm._v(" "), _c('div', {
      staticClass: "arrow-flex"
    }, [_c('div', {
      staticClass: "arrow"
    }, [_c('inline-svg', {
      class: _vm.pickedType == section ? 'upside-arrow' : 'down-arrow',
      attrs: {
        "src": __webpack_require__(227).default
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "lessons-wrapper"
    }, _vm._l((section.lessons), function(videoa) {
      return _c('div', {
        key: videoa.id,
        staticClass: "step",
        class: {
          completed: _vm.userProgress.includes(videoa.id)
        },
        on: {
          "click": function($event) {
            return _vm.openLesson(videoa.id, videoa.permission)
          }
        }
      }, [_c('div', {
        staticClass: "v-stepper-course"
      }, [_c('div', {
        staticClass: "circle"
      }, [(_vm.userProgress.includes(videoa.id)) ? _c('inline-svg', {
        staticClass: "check-v-ex",
        attrs: {
          "src": __webpack_require__(280).default
        }
      }) : _vm._e(), _vm._v(" "), (
        videoa.permission !== 'unknown' &&
        videoa.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        videoa.permission == 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": __webpack_require__(249).default
        },
        on: {
          "click": _vm.goPay
        }
      }) : _vm._e(), _vm._v(" "), (
        videoa.permission !== 'unknown' &&
        videoa.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        videoa.permission == 'registered'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "src": __webpack_require__(212).default
        }
      }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "gameText",
        class: {
          disbaled: videoa.permission !== 'unknown' &&
            videoa.permission !== _vm.permission &&
            _vm.permission !== 'paying'
        }
      }, [_vm._v("\n              " + _vm._s(videoa.name) + "\n            ")])])
    }), 0)])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 11.ce03fd3d81a126f24b18.bundle.js